module.exports = __webpack_public_path__ + "static/img/sw3.1206ec17.png";